import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import {SERVER_URL} from '../../shared/utils/Constants';
import {toast} from 'react-toastify';

import ReCAPTCHA from 'react-google-recaptcha';

import OutlinedInput from "@material-ui/core/OutlinedInput";
import PasswordResetInit from "./PasswordResetInit";
import PasswordResetFinish from "./PasswordResetFinish";
import Package from "../../../package.json";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import SystemParamsService from "../../shared/service/SystemParamsService";
import CurrentUserService from "../../shared/service/CurrentUserService";
import './LoginPage.css';

global.appVersion = Package.version;

class Login extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            reCaptchaToken: null,
            userName: null,
            password: null,
            panel: 'login',
            loginShow: true,
            showCaptcha: true

        };

        this.systemParamsService = new SystemParamsService();
        this.currentUserService = new CurrentUserService();
    }

    componentDidMount() {

        this.systemParamsService.getSystemParams().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    showCaptcha: response.showCaptcha,
                });
            }
            }
        );

        if (this.reCAPTCHA) {
            this.reCAPTCHA.reset();
        }

        if (GeneralUtils.getParameterByName('passwordChangeKey') !== null) {
            this.setState({
                panel: 'passwordResetFinish',
                passwordChangeKey: GeneralUtils.getParameterByName('passwordChangeKey')
            });
        }
        if (GeneralUtils.getParameterByName('activationKey') !== null) {
            this.setState({
                panel: 'passwordResetFinish',
                activationKey: GeneralUtils.getParameterByName('activationKey')
            });
        }


    }

    onChange = (reCaptchaToken) => {
        this.setState({reCaptchaToken: reCaptchaToken});
    }

    isLoginSubmitDisabled = () => {
        return this.state.showCaptcha && !this.state.reCaptchaToken;
    }

    renderBrand() {
        return (
            <div className="login-page__brand">
                <img
                    className="login-page__logo"
                    alt="Dispatchio"
                    src="assets/layout/images/dispatchio.png"/>
                <p className="login-page__version">V {global.appVersion}</p>
            </div>
        );
    }

    render() {
        if (this.state.panel === 'login') {
            return this.getLoginPanel();
        } else {
            return this.getPasswordResetPanel();
        }

    }

    getPasswordResetPanel = () => {
        const title = !GeneralUtils.isNullOrEmpty(this.state.activationKey)
            ? 'User Activation'
            : 'Reset Password';

        return (
            <div className="login-page login-background">
                <main className="login-page__main">
                    <CssBaseline/>
                    <div className="login-page__card">
                        {this.renderBrand()}
                        <Typography component="h1" variant="h6" className="login-page__title">
                            {title}
                        </Typography>
                        <div className="login-page__reset-body">
                            {this.getPasswordResetContent()}
                        </div>
                        <Button
                            fullWidth
                            variant="outlined"
                            color="primary"
                            className="login-page__back"
                            onClick={() => {
                                this.setState({panel: 'login'});
                                GeneralUtils.returnMainPage();
                            }}>
                            Back to login
                        </Button>
                    </div>
                </main>
            </div>
        );
    }

    getLoginPanel = () => {
        const submitDisabled = this.isLoginSubmitDisabled();

        return (
            <div className="login-page login-background">
                <main className="login-page__main">
                    <CssBaseline/>
                    <div className="login-page__card">
                        {this.renderBrand()}
                        <form className="login-page__form" onSubmit={(e) => e.preventDefault()}>
                            <FormControl margin="normal" required fullWidth variant="outlined" className="login-page__field">
                                <InputLabel htmlFor="userName">User Name</InputLabel>
                                <OutlinedInput
                                    id="userName"
                                    name="userName"
                                    autoComplete="username"
                                    value={this.state.userName || ''}
                                    onChange={this.__handleChange}
                                    autoFocus/>
                            </FormControl>
                            <FormControl margin="normal" required fullWidth variant="outlined" className="login-page__field">
                                <InputLabel htmlFor="password">Password</InputLabel>
                                <OutlinedInput
                                    name="password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    value={this.state.password || ''}
                                    onChange={this.__handleChange}/>
                            </FormControl>

                            <button
                                type="button"
                                className="login-page__forgot"
                                disabled={submitDisabled}
                                onClick={() => this.setState({panel: 'passwordResetInit'})}>
                                Forgot Password
                            </button>

                            {this.state.showCaptcha && (
                                <div className="login-page__captcha">
                                    <ReCAPTCHA
                                        ref={(el) => {
                                            this.reCAPTCHA = el;
                                        }}
                                        hl="en"
                                        size="normal"
                                        sitekey="6LdsjTUfAAAAAH7TpbjBwaRYmvtPEV5YqJZeXdWK"
                                        onChange={this.onChange}/>
                                </div>
                            )}

                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                disabled={submitDisabled}
                                className="login-page__submit"
                                onClick={() => this.login()}>
                                Login
                            </Button>
                        </form>
                    </div>
                </main>
            </div>
        );
    }

    getPasswordResetContent = () => {
        if (this.state.panel === 'passwordResetInit') {
            return <PasswordResetInit/>;
        } else if (this.state.panel === 'passwordResetFinish') {
            return <PasswordResetFinish activationKey={this.state.activationKey}
                                        passwordChangeKey={this.state.passwordChangeKey}/>;
        }
    }

    __handleChange = (e) => {
        let state = {};
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        state[e.target.name] = value;
        this.setState(state);
    }

    login = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.userName) || GeneralUtils.isNullOrEmpty(this.state.password)) {
            return toast.warn("User name and password  cannot be empty!")
        }
        const loginPayload = {
            userName: this.state.userName,
            password: this.state.password.toString(),
            reCaptchaToken: this.state.reCaptchaToken
        };
        console.log('[Login] Request URL:', SERVER_URL + 'security/auth/login');
        console.log('[Login] Request payload (password masked):', { ...loginPayload, password: '***' });

        window.location.hash = "/";
        localStorage.setItem("userType", "admin");
        fetch(SERVER_URL + 'security/auth/login', {
            crossDomain: true,
            method: 'post',
            headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'},
            body: JSON.stringify(loginPayload),
        })
            .then(response => {
                console.log('[Login] Login response status:', response.status, response.statusText);
                if (response.ok) {

                    response.json().then((response) => {
                        console.log('[Login] Login response body:', response);
                        if (!GeneralUtils.isNullOrEmpty(response["authCode"])) {
                            console.log('[Login] AuthCode received, fetching token...');
                            fetch(SERVER_URL + 'security/auth/token/code/' + response["authCode"], {
                                crossDomain: true,
                                method: 'post',
                                headers: {'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json'}
                            })
                                .then(response => {
                                    console.log('[Login] Token response status:', response.status);
                                    if (response.ok) {
                                        response.json().then((response) => {
                                            console.log('[Login] Token response body (accessToken/refreshToken length):', {
                                                accessTokenLength: response.accessToken?.length,
                                                refreshTokenLength: response.refreshToken?.length,
                                                expireDate: response.expireDate
                                            });

                                            localStorage.setItem("isAuthenticated", true);

                                            GeneralUtils.setJwtToCookie(response.accessToken, response.refreshToken, response.expireDate)
                                                .then(() => {
                                                    return this.currentUserService.getCurrentAdminOrMemberUser();
                                                })
                                                .then(responseAdminUser => {
                                                    console.log('[Login] Current user:', responseAdminUser);
                                                    if (!GeneralUtils.isNullOrEmpty(responseAdminUser) && GeneralUtils.isNullOrEmpty(responseAdminUser.type)) {
                                                        localStorage.setItem("hsmUser", JSON.stringify(responseAdminUser));
                                                        this.props.loginSuccess();
                                                    }
                                                })
                                                .catch(err => {
                                                    console.error('[Login] getCurrentAdminOrMemberUser error:', err);
                                                });


                                        });

                                    } else {
                                        console.warn('[Login] Token request failed:', response.status);
                                        this.setState({userName: '', password: ''});
                                        GeneralUtils.notification(response);

                                    }
                                }).catch(error => {
                                console.error('[Login] Token fetch error:', error);
                                GeneralUtils.notification(error);
                            });
                        } else {
                            console.log('[Login] No authCode in response');
                        }

                    });

                } else {
                    console.warn('[Login] Login request failed:', response.status);
                    this.setState({userName: '', password: ''});
                    GeneralUtils.notification(response);

                }
            }).catch(error => {
            console.error('[Login] Login fetch error:', error);
            GeneralUtils.notification(error);
        });
    }


}


Login.propTypes = {
    loginSuccess: PropTypes.func,
};

export default Login;
